import { SETTINGS_SET_VIEW_MODE, SETTINGS_TOGGLE_VIEW_MODE } from './types';

export const actions = {
  [SETTINGS_TOGGLE_VIEW_MODE]: ({ commit }, payload) => {
    commit(SETTINGS_SET_VIEW_MODE, payload);
  }
};
